export const checkRequiredFields = ({ familyName, givenName, locality, addressLines, countryCode, postalCode }) => {
  const validationErrors = [];
  const address = addressLines.map(el => el.trim()).filter(el => el).join(', ');

  if (!familyName?.trim() || !givenName?.trim()) {
    validationErrors.push({ contactField: 'name', message: 'Please enter your full name.' });
  }

  if (!locality?.trim()) {
    validationErrors.push({ contactField: 'locality', message: 'City is a required field.' });
  }

  if (address.length === 0) {
    validationErrors.push({ contactField: 'addressLines', message: 'Address is a required field.' });
  }

  if (!countryCode) {
    validationErrors.push({ contactField: 'countryCode', message: 'Country is a required field.' });
  }

  if (!postalCode?.trim()) {
    validationErrors.push({ contactField: 'postalCode', message: 'ZIP/Postal code is a required field.' });
  }

  return validationErrors.length > 0 ? validationErrors : null;
}; 